fragment TrainingCategoryFields on TrainingCategory {
  id
  name
  position
  archived
  courseCount
}
